// extracted by mini-css-extract-plugin
export default {"titleBtnBox":"vU_sUsp3HLpT9EcKZXYE"};